export const toMajorUnit = (amount: number): number => amount / 100;
